import { CheckItem } from "components/WebDesigner/StyleInputs/CategorySelector";
import { Fragment, useState } from "react";
import ReactDOM from "react-dom";
import VGPopUp from "vagaro-website-rendering/src/components/Controls/VGPopUp";


export function BusinessTypeFilter({subtext,inCategories,onUpdate,inSelectedCategories}:{subtext:string,inCategories:any[],inSelectedCategories:string[],onUpdate:(selectedCategories:string[])=>void}){

    const [selectedCategories,setSelectedCategories] = useState<string[]>(inSelectedCategories??[]);
    
    const mainCategories:any[] = [];
    const subCategories:any[] = [];

    for(let i = 0;i<inCategories.length;i++){

        let item = inCategories[i];
        if(item.parentCategoryId){
          
            subCategories.push(item);
        }
        else{
            mainCategories.push(item);
        }
    }
    

    return <>

    <div className="flex-column" >
    <div style={{fontSize:"16px",lineHeight:"20px",paddingBottom:"20px",color:"#6D6E6F",fontWeight:"400"}}>{subtext}</div>
    {
        mainCategories.map((item:any,index:number)=>{

            return <Fragment key={index}> <div className="flex-row-to-column-475 align-start">
                <div className="cat-heading h-full flex-column " style={{width:"200px",fontWeight:"bold",fontSize:"20px",padding:"16px 0 0 8px",}}>{item.name}</div>
                <div className="flex-row flex-wrap " style={{flex:"1",padding:"8px 0px",}}>
                    {
                        subCategories.filter((subItem:any)=>subItem.parentCategoryId === item.id).map((subItem:any,i:number)=>{

                            const onToggle = ()=>{
                                let isChecked = !selectedCategories.includes(subItem.id);
                                if(isChecked){
                                    let newCats = [...selectedCategories,subItem.id];
                                    onUpdate(newCats);
                                    setSelectedCategories(newCats);
                                    
                                }
                                else{
                                    let newCats = selectedCategories.filter((id)=>id!==subItem.id);
                                    onUpdate(newCats);
                                    setSelectedCategories(newCats);
                                }
                            }

                            return <div className="business-type-check flex-row gap-med align-center" key={i} >
                                <CheckItem item={subItem.name}  styling={{fontWeight:500,padding:"8px 0px",fontSize:"16px",gap:"12px"}}checked={selectedCategories.includes(subItem.id)} onClickFunc={()=>{onToggle()}}/>
                            </div>
                        })
                    }

            </div>
            </div>
            {index<mainCategories.length-1&&<hr/>}
            </Fragment>  
            })
    }



    </div>

    </>

}


export function OpenBusinessTypePopup(title:string,subtext:string,inCategories:any[],selectedCategories:string[],onSubmit:(selectedCategories:string[])=>void){

    const dom =  document.getElementById("OpenDialog1");
   
    const PopupClose = ()=>{

        if(dom){
            ReactDOM.unmountComponentAtNode(dom);
        }
      
    }

    const filters:{selectedCategories:any[]} = {
        selectedCategories:[]
    }



    ReactDOM.render(
        <>
        <VGPopUp
          id={"b-filter-popup"}
          show={true}
          onHide={PopupClose}
          title={title}
          dialogClassName="block-edit"
          body={
            <div className="alertContent">
                <BusinessTypeFilter subtext={subtext} inCategories={inCategories} inSelectedCategories={selectedCategories} onUpdate={(cats:any[])=>{filters.selectedCategories = cats}}/>
            </div>
          }
          footer={
            <Fragment>
                     <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                      <button className="w-button w-button-primary" onClick={() =>{onSubmit(filters.selectedCategories); PopupClose();}}>Apply</button>

            </Fragment >
          }
          isRemoveTabModalIndex={false}
          isShowFooter={true}
          size={"modal-sm"}
          backdrop={true}
        />
  
        </>,
        dom);

}